import { render, staticRenderFns } from "./StampDuty.vue?vue&type=template&id=9753c98a"
import script from "./StampDuty.vue?vue&type=script&lang=js"
export * from "./StampDuty.vue?vue&type=script&lang=js"
import style0 from "./StampDuty.vue?vue&type=style&index=0&id=9753c98a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports